import Cookies from 'universal-cookie';
import { getDatePlusYear } from './date-time-helpers';
import { getDomain } from './get-domain';

const CURRENT_ORGANIZATION_NUMBER = 'cur-org-number';
const USER_AUTHED = 'user-auth-b2b';

export const tryReadCurrentOrganizationNumberFromCookie = (): string | undefined => {
  const cookieConfig = new Cookies(document.cookie);

  return cookieConfig.get(CURRENT_ORGANIZATION_NUMBER);
};

export const writeCurrentOrganizationNumberToCookie = (currentNumber: string) => {
  const cookieConfig = new Cookies(document.cookie);
  const domain = getDomain(window.location.hostname);

  return cookieConfig.set(CURRENT_ORGANIZATION_NUMBER, currentNumber, {
    path: '/',
    expires: getDatePlusYear(),
    domain: `.${domain}`,
  });
};

// NOTE: doesn't have document
export const isB2BUserAuthedSSR = (cookie: Record<string, string>) => {
  const value = cookie[USER_AUTHED];

  return value === 'true';
};

export const isB2BUserAuthedClient = () => {
  const cookieConfig = new Cookies(document.cookie);

  return cookieConfig.get(USER_AUTHED) === 'true';
};
